module.exports = __webpack_public_path__ + "img/img-enfp.0a1e085a.jpg";